module.exports = __webpack_public_path__ + "static/media/tz.9b0ba0ba.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tz.svg
// module id = 2234
// module chunks = 0